import { useTranslation } from 'react-i18next';
import { InfoTooltip } from '@frekuent/orbit/components';

type LabelWithTooltipProps = {
	name: string;
	tooltipText: string;
	/**
	 * @deprecated No longer rendered. Retained only because `Label` uses `tooltipId && tooltipText`
	 * as the gate for its tooltip branch — removing it would disable tooltips for all callers.
	 */
	tooltipId?: string;
	label?: string;
	htmlFor?: string;
	required?: boolean;
};

const LabelWithTooltip = ({
	name,
	tooltipText,
	label,
	htmlFor,
	required,
}: LabelWithTooltipProps) => {
	const { t } = useTranslation();

	return (
		<div className='mb-2 flex items-center gap-2'>
			<label
				htmlFor={htmlFor || name}
				className='first-letter-uppercase'
			>
				{t(label || '')}
				{required && <span className='ml-2 text-sm'>*</span>}
			</label>
			<InfoTooltip
				content={t(tooltipText)}
				trigger='click'
				iconSize={17}
				iconClassName='[&_path]:fill-[var(--color-icon-tertiary)]'
			/>
		</div>
	);
};

export default LabelWithTooltip;
